import { render, staticRenderFns } from "./BackgroundPrimaryColorSVG.vue?vue&type=template&id=a07e60e0"
import script from "./BackgroundPrimaryColorSVG.vue?vue&type=script&lang=ts"
export * from "./BackgroundPrimaryColorSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports